import { Link, useLocation, useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Sprout, TestTube, Map, CloudSun, LogOut, LayoutDashboard, Bug, MapPin, Smartphone, Users, Mic, ShoppingBasket } from "lucide-react";
import { Button } from "@/components/ui/button";

const links = [
  { to: "/app", label: "Dashboard", icon: LayoutDashboard, testid: "nav-dashboard" },
  { to: "/app/analyze", label: "Soil", icon: TestTube, testid: "nav-analyze" },
  { to: "/app/pest", label: "Pest Doctor", icon: Bug, testid: "nav-pest" },
  { to: "/app/ask", label: "Ask", icon: Mic, testid: "nav-ask" },
  { to: "/app/fields", label: "Fields", icon: Map, testid: "nav-fields" },
  { to: "/app/map", label: "Map", icon: MapPin, testid: "nav-map" },
  { to: "/app/groups", label: "Groups", icon: Users, testid: "nav-groups" },
  { to: "/app/market", label: "Market", icon: ShoppingBasket, testid: "nav-market" },
  { to: "/app/offline", label: "Offline", icon: Smartphone, testid: "nav-offline" },
  { to: "/app/weather", label: "Weather Advice", icon: CloudSun, testid: "nav-weather" },
];

export function Navbar() {
  const { user, logout } = useAuth();
  const { pathname } = useLocation();
  const navigate = useNavigate();

  return (
    <header className="sticky top-0 z-50 backdrop-blur-md bg-emerald-950/90 text-emerald-50 border-b border-emerald-800/50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 flex items-center justify-between h-16 gap-4">
        <Link to="/app" className="flex items-center gap-2 shrink-0" data-testid="nav-logo">
          <div className="h-9 w-9 rounded-xl bg-[#52B788] flex items-center justify-center">
            <Sprout className="h-5 w-5 text-emerald-950" />
          </div>
          <span className="font-display font-extrabold text-lg tracking-tight hidden sm:block">AgroTerra</span>
        </Link>

        <nav className="flex items-center gap-0.5 overflow-x-auto min-w-0 flex-1 justify-center [scrollbar-width:none]">
          {links.map((l) => {
            const active = pathname === l.to;
            return (
              <Link
                key={l.to}
                to={l.to}
                data-testid={l.testid}
                title={l.label}
                className={`flex items-center gap-1.5 px-2.5 py-2 rounded-lg text-[13px] font-medium whitespace-nowrap transition-colors ${
                  active ? "bg-[#52B788] text-emerald-950" : "text-emerald-100/80 hover:bg-emerald-800/60 hover:text-white"
                }`}
              >
                <l.icon className="h-4 w-4 shrink-0" />
                <span className="hidden xl:inline">{l.label}</span>
              </Link>
            );
          })}
        </nav>

        <div className="flex items-center gap-3 shrink-0">
          <div className="text-right hidden 2xl:block leading-tight">
            <div className="text-sm font-semibold">{user?.name}</div>
            <div className="text-xs text-emerald-200/70">{user?.farm_name || "Farmer"}</div>
          </div>
          <Button
            data-testid="logout-btn"
            variant="ghost"
            size="sm"
            className="text-emerald-100 hover:bg-emerald-800/60 hover:text-white"
            onClick={() => { logout(); navigate("/"); }}
          >
            <LogOut className="h-4 w-4" />
          </Button>
        </div>
      </div>
    </header>
  );
}
